<template>
  <div class="sign-in-wrapper">
    <div id="forgot_pw">
      <Errors :errors="errors" />
      <div
        v-if="showSuccessMessage"
        align="center"
      >
        <div class="icon icon--order-success svg add_bottom_15">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
          >
            <g
              fill="none"
              stroke="#8EC343"
              stroke-width="2"
            >
              <circle
                cx="36"
                cy="36"
                r="35"
                style="stroke-dasharray:240px, 240px; stroke-dashoffset: 480px;"
              />
              <path
                d="M17.417,37.778l9.93,9.909l25.444-25.393"
                style="stroke-dasharray:50px, 50px; stroke-dashoffset: 0px;"
              />
            </g>
          </svg>
        </div>
        <p>{{ $t('lang.alerts.email_success') }}</p>
        <p>{{ $t('lang.alerts.email_success_message') }}</p>
      </div>

      <form
        v-if="!showSuccessMessage"
        @submit="formSubmit"
      >
        <div
          class="form-group"
        >
          <label>{{ $t('lang.forgot_password.text') }}</label>
          <input
            v-model="formData.email"
            type="email"
            class="form-control"
            name="email"
            required
          >

          <i class="icon_mail_alt" />
        </div>

        <p>{{ $t('lang.forgot_password.explanation') }}</p>

        <button
          v-if="!showSuccessMessage"
          type="submit"
          class="btn_1 full-width mt-4"
          :disabled="validated"
        >
          <span v-if="validated && !showSuccessMessage"><i
            class="icon-spin6 animate-spin"
            style="font-size: 130%"
          /></span>
          <span v-else>{{ $t('lang.forgot_password.button') }}</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Errors from '../Alerts/Errors';
import { API, errorResponse } from '../../api/api';

const AuthAPI = API.get('auth');

// @vuese
// Componente dentro de la vista de Login,
// con formulario para enviar email de restauración de contraseña
export default {
  name: 'ForgotPassword',

  components: {
    Errors,
  },

  data() {
    return {
      formData: {
        email: '',
      },

      showSuccessMessage: false,
      errors: {},
      validated: false,
    };
  },

  methods: {

    async formSubmit(e) {
      e.preventDefault();

      this.validated = true;

      this.errors = {};

      try {
        await AuthAPI.forgotPassword(this.formData);
        this.showSuccessMessage = true;
      } catch (error) {
        this.validated = false;
        this.errors = errorResponse(error);
      }
      window.scrollTo(0, 0);
      this.validated = false;
    },

  },
};
</script>

<style scoped>

</style>
